export default class Cache {
	static repositoryName = 'e-lazyload-cache';
	static cache = null;

	/**
	 * internal
	 * @returns {null|object}
	 */
	static getRepository() {
		if ( ! Cache.cache ) {
			const data = window.localStorage.getItem( Cache.repositoryName );
			Cache.cache = ( data ) ? JSON.parse( data ) : null;
		}
		return Cache.cache;
	}

	/**
	 * internal
	 * @param value
	 */
	static setRepository( value ) {
		window.localStorage.setItem( Cache.repositoryName, JSON.stringify( value ) );
		Cache.cache = null;
	}

	/**
	 * internal
	 * @param key
	 * @returns {mixed|object|null}
	 */
	static getCachedEntry( key ) {
		const data = Cache.getRepository();
		if ( ! data ) {
			return null;
		}
		const {
			[ key ]: cacheEntry = null,
		} = data;
		return cacheEntry;
	}

	/**
	 * validate cache expire
	 * @param cacheEntry
	 * @returns {boolean}
	 */
	static isValid( cacheEntry ) {
		return ( cacheEntry.value && cacheEntry.expire && cacheEntry.expire > Date.now() );
	}

	/**
	 * get cached entry by key
	 * @param key
	 * @param {boolean} validate
	 * @returns {null|*} null when not found or invalid
	 */
	static get( key, validate = true ) {
		const cacheEntry = Cache.getCachedEntry( key );
		if ( ! cacheEntry ) {
			return null;
		}

		if ( ! validate ) {
			return ( cacheEntry.value ) ? cacheEntry.value : null;
		}

		if ( ! Cache.isValid( cacheEntry ) ) {
			Cache.del( key );
			return null;
		}
		return cacheEntry.value;
	}

	/**
	 * set cache entry
	 * @param key
	 * @param value
	 * @param ttl
	 */
	static set( key, value, ttl = 30 ) {
		const data = Cache.getRepository(),
			expire = Date.now() + ( ttl * 1000 * 60 ); // ttl minutes in milliseconds

		Cache.setRepository( {
			... data,
			[ key ]: {
				expire,
				value,
			}
		} );
	}

	/**
	 * delete a cached entry
	 * @param key
	 */
	static del( key ) {
		const data = Cache.getRepository();
		const {
			[ key ]: cacheEntry = null, // eslint-disable-line no-unused-vars
			...restOfData
		} = data;

		Cache.setRepository( restOfData );
	}

	/**
	 * check if cached value exists
	 * @param key
	 * @returns {boolean}
	 */
	static exists( key ) {
		const cacheEntry = Cache.getCachedEntry( key );
		return null !== cacheEntry;
	}

	/**
	 * check if cached value exists and is valid
	 * @param key
	 * @returns {boolean}
	 */
	static existsAndValid( key ) {
		const cacheEntry = Cache.getCachedEntry( key );
		return Cache.exists( key ) && Cache.isValid( cacheEntry );
	}
}
